import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';
/**
 * Log image uploading for compose
 * @param attachmentFileType The attachment file type
 */
export default function logImageUpload(attachmentFileType: string) {
    // Log the datapoint
    const eventName = 'InlineImageAttachmentUpload';
    const cd = [attachmentFileType];
    logUsage(eventName, cd);
    trace.info(`${eventName}: ${cd}`);
}
